import { Controller } from '@hotwired/stimulus';

const test_clientKey = 'test_ck_OAQ92ymxN34QA7lb7LgVajRKXvdk';

const live_clientKey = 'live_ck_d26DlbXAaV0DXx1LvL0VqY50Q9RB';

const tossPayments = TossPayments(live_clientKey);

export default class extends Controller {
  static targets = ['paymentsModal', 'productPrice', 'productName', 'age', 'ageError'];

  static values = { responseUrl: String };

  connect() {}

  click(event) {
    const { successUrl, failUrl, membershipId, customerKey } = event.params;

    if (!this.validate(this.ageTarget, this.ageErrorTarget, event)) {
      return;
    }

    tossPayments
      .requestBillingAuth('카드', {
        // 결제수단 파라미터
        // 빌링키 발급 요청을 위한 파라미터
        successUrl: `${successUrl}?membershipId=${membershipId}`,
        customerKey: customerKey,
        failUrl: failUrl,
      })
      .catch(function (error) {
        if (error.code === 'USER_CANCEL') {
          // 결제 고객이 결제창을 닫았을 때 에러 처리
        } else if (error.code === 'INVALID_CARD_COMPANY') {
          // 유효하지 않은 카드 코드에 대한 에러 처리
        }
      });
  }

  cancel() {
    this.paymentsModalTarget.classList.add('hidden');
  }

  validate(target, error, event) {
    if (!target.checked) {
      error.classList.remove('hidden');
      event.preventDefault();
      return false;
    }
    error.classList.contains('hidden') || error.classList.add('hidden');
    return true;
  }
}
